export default "__VITE_ASSET__BWpbSRjG__"